import { render, staticRenderFns } from "./RateFilter.vue?vue&type=template&id=ef5bd81e&"
import script from "./RateFilter.vue?vue&type=script&lang=js&"
export * from "./RateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports